import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OfferSearchBarComponent } from './offer-search-bar.component';
import { FormsModule } from '@angular/forms';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';

@NgModule({
  declarations: [OfferSearchBarComponent],
  imports: [
    CommonModule,
    FormsModule,
    FGBSharedModule
  ],
  exports: [OfferSearchBarComponent],
})
export class OfferSearchBarModule {}
